/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Contact_LeadInputs */

const en_mk_abt_contact_lead = /** @type {(inputs: Mk_Abt_Contact_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The fastest way to judge the fit is to try it — the Free plan asks for no card. If you would rather ask first, the pages below usually hold the answer.`)
};

const id_mk_abt_contact_lead = /** @type {(inputs: Mk_Abt_Contact_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara tercepat menilai apakah ini cocok adalah mencobanya — paket Gratis tidak meminta kartu. Kalau Anda ingin bertanya lebih dulu, halaman-halaman di bawah biasanya sudah memuat jawabannya.`)
};

/**
* | output |
* | --- |
* | "The fastest way to judge the fit is to try it — the Free plan asks for no card. If you would rather ask first, the pages below usually hold the answer." |
*
* @param {Mk_Abt_Contact_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_contact_lead = /** @type {((inputs?: Mk_Abt_Contact_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Contact_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_contact_lead(inputs)
	return en_mk_abt_contact_lead(inputs)
});